import React, { Component } from "react";
import { FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import config from "../config";
import "./NewNote.css";
import { API } from "aws-amplify";
import { s3Upload } from "../libs/awsLibs";

export default class NewNote extends Component {
    constructor(props) {
        super(props);

        this.file = null;

        this.state = {
            isLoading: null,
            remark: ""
        };
    }

    validateForm() {
        return this.state.remark.length > 0;
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    }

    handleFileChange = event => {
        this.file = event.target.files[0];
    }

    handleSubmit = async event => {
        event.preventDefault();

        if (this.state.remark.trim().length <= 0) {
            alert(`Please write a remark for your license request.`);
            return;
        }
        else if (!this.file) {
            alert(`Please upload your license request zip file.`);
            return;
        }
        else if (!this.file.name.endsWith('.zip')) {
            alert(`Portunes only supported license request zip file at this moment.`);
            return;
        }
        else if (this.file && this.file.size > config.MAX_ATTACHMENT_SIZE) {
            alert(`Please pick a file smaller than ${config.MAX_ATTACHMENT_SIZE/1000000} MB.`);
            return;
        }

        this.setState({ isLoading: true });

        try {
            const reqAttachment = this.file
                ? await s3Upload(this.file)
                : null;

            await this.createNote({
                reqAttachment: reqAttachment,
                remark: this.state.remark.trim()
            });
            this.props.history.push("/");
        } catch (e) {
            alert(e);
            this.setState({isLoading: false});
        }
    }

    createNote(note) {
        return API.post("portunes", "/req", {
            body: note
        });
    }

    render() {
        return (
            <div className="NewNote">
                <form onSubmit={this.handleSubmit}>
                    <FormGroup controlId="remark">
                        <FormControl
                            onChange={this.handleChange}
                            value={this.state.remark}
                            componentClass="textarea"
                        />
                    </FormGroup>
                    <FormGroup controlId="file">
                        <ControlLabel>License Request Zip File</ControlLabel>
                        <FormControl onChange={this.handleFileChange} type="file" />
                    </FormGroup>
                    <LoaderButton
                        block
                        bsStyle="primary"
                        bsSize="large"
                        disabled={!this.validateForm()}
                        type="submit"
                        isLoading={this.state.isLoading}
                        text="Create"
                        loadingText="Creating…"
                    />
                </form>
            </div>
        );
    }
}